/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Report_Reason_InstructionsInputs */

const en_us2_exercise_sheet_report_reason_instructions = /** @type {(inputs: Exercise_Sheet_Report_Reason_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions`)
};

const pt_br2_exercise_sheet_report_reason_instructions = /** @type {(inputs: Exercise_Sheet_Report_Reason_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruções`)
};

const es_419_exercise_sheet_report_reason_instructions = /** @type {(inputs: Exercise_Sheet_Report_Reason_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrucciones`)
};

const pt_pt2_exercise_sheet_report_reason_instructions = /** @type {(inputs: Exercise_Sheet_Report_Reason_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruções`)
};

const fr_fr2_exercise_sheet_report_reason_instructions = /** @type {(inputs: Exercise_Sheet_Report_Reason_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions`)
};

const de_de2_exercise_sheet_report_reason_instructions = /** @type {(inputs: Exercise_Sheet_Report_Reason_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anleitung`)
};

const it_it2_exercise_sheet_report_reason_instructions = /** @type {(inputs: Exercise_Sheet_Report_Reason_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istruzioni`)
};

/**
* | output |
* | --- |
* | "Instructions" |
*
* @param {Exercise_Sheet_Report_Reason_InstructionsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_report_reason_instructions = /** @type {((inputs?: Exercise_Sheet_Report_Reason_InstructionsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Report_Reason_InstructionsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_report_reason_instructions(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_report_reason_instructions(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_report_reason_instructions(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_report_reason_instructions(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_report_reason_instructions(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_report_reason_instructions(inputs)
	return en_us2_exercise_sheet_report_reason_instructions(inputs)
});
export { exercise_sheet_report_reason_instructions as "exercise-sheet.report_reason_instructions" }